import { makeModelSelectors } from '@minerva-analytics/pantheon';
import all from './all';
import selectedCategoryPages from './selectedCategoryPages';

export default {
  ...makeModelSelectors({ model: `category`, pluralModel: `categories`, exclude: [`all`] }),
  all,
  selectedCategoryPages,
};
